import { Injectable } from '@angular/core';

import { map, Observable, of } from 'rxjs';
import { SiteSettings } from '@reg/shared/model';
import { HttpServiceHelper } from '@reg/shared/service/http-service-helper';
import { IJsonApiResponse } from '../json-api/json-api.interface';
import { observableInSeparateThread } from '../helper/observable-helper';

/**
 * Service to get site settings from the core db
 */
@Injectable()
export class SiteSettingsService {
    private cachedSettingsMap: { [apiRequest: string]: SiteSettings; } = {};

    /**
     * Constructor
     */
    constructor(private http: HttpServiceHelper) {
    }

    /**
     * Get all site settings for a given site id
     */
    public getBySiteId(
        siteId: number,
        displaySpinner: boolean = true,
        forceRefresh: boolean = false,
    ): Observable<SiteSettings> {
        const apiBaseUrl: string = this.http.configService.getBaseConfig('flosportsApiBaseUrl');
        const apiRequestUrl: string = `${apiBaseUrl}/api/site-settings?site_id=${siteId}`;

        if (!forceRefresh &&
            this.cachedSettingsMap[apiRequestUrl]) {
            // if cache is available just return it as `Observable`
            return observableInSeparateThread(this.cachedSettingsMap[apiRequestUrl]);
        }
        // Make the http request
        return this.http.get(apiRequestUrl, displaySpinner, true, this.http.getHeadersForJson(false))
            .pipe(map((response: IJsonApiResponse) => {
                const settings: SiteSettings = (new SiteSettings()).deserialize(response);
                this.cachedSettingsMap[apiRequestUrl] = settings;
                return settings;
            }));
    }
}
